import {BASE_URL,PATCH,UPDATE_SERVICE} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import {getAccessToken} from "../../authActions/authActions";
  
  export const UpdateServiceRequest = async(payload,id) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${UPDATE_SERVICE}/${id}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
    .then(statusParsing)
    .then(jsonParsing);
  };